import React, { useState } from 'react';
import classNames from 'classnames';
import RevisionNumber from 'utils/components/RevisionNumber/RevisionNumber';
import 'utils/components/RevisionNumber/RevisionNumber.scss';
import { useDispatchSetAlgorithmParametersRevisionIndex } from 'widgets/store/shared/algoParameters/dispatcher';
import { useSelectAlgorithmParametersRevisionIndex } from 'widgets/store/shared/algoParameters/selectors';
import './XAxisRevisionLabel.scss';
import XAxisLabel from 'widgets/fillsGraph/axisLabel/XAxisLabel';
import { useXAxisLabelTimeLine } from 'widgets/fillsGraph/axisLabel/useXAxisLabelTimeLine';

export interface XAxisRevisionLabelProps {
    top: number;
    left: number;
    revisionIndex: number;
    boxLeft?: number;
    time: number;
}

export default function XAxisRevisionLabel({
    top,
    left,
    revisionIndex,
    boxLeft,
    time,
}: XAxisRevisionLabelProps) {
    const sharedStateRevisionIndex =
        useSelectAlgorithmParametersRevisionIndex();
    const listIndex =
        sharedStateRevisionIndex !== undefined ? sharedStateRevisionIndex : -1;

    const dispatchSetIndexAction =
        useDispatchSetAlgorithmParametersRevisionIndex();

    const selected = revisionIndex === listIndex;

    const [isHovering, setIsHovering] = useState(false);

    useXAxisLabelTimeLine(boxLeft, time, isHovering, 'revision-label');

    return (
        <XAxisLabel
            className={classNames('XAxisRevisionLabel', selected && 'selected')}
            top={top}
            left={left}
            boxLeft={boxLeft}
            time={time}
        >
            <RevisionNumber
                valIndex={revisionIndex}
                listIndex={listIndex}
                setIndex={dispatchSetIndexAction}
                showLabel
                onIsHoveringChanged={setIsHovering}
            />
        </XAxisLabel>
    );
}
